import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Spinner from "react-bootstrap/Spinner";

import { PatientSearch } from "../SearchPatients/SearchPatients";
import { linkConversation } from "../../whatsappApi";

/**
 * LinkPatientModal — attaches an unmatched WhatsApp number to a patient.
 *
 * Unmatched threads are shown rather than hidden: the patient messaged the
 * practice, so the message matters even though the number is not on file.
 */
export default function LinkPatientModal({
  show,
  onHide,
  practiceNumber,
  conversation,
  onLinked,
  showToast,
}) {
  const [saving, setSaving] = useState(false);

  const link = async (patient) => {
    if (!patient?._id) return;
    setSaving(true);
    try {
      const { conversation: updated } = await linkConversation(
        practiceNumber,
        conversation._id,
        patient._id,
      );
      showToast?.("success", "Conversation linked to patient.");
      onLinked?.(updated);
      onHide?.();
    } catch (err) {
      showToast?.(
        "danger",
        err?.response?.data?.error || "Could not link this conversation.",
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header
        closeButton
        style={{ background: "#CFE2FF" }}
        className="rounded-0 text-primary d-flex align-items-center"
      >
        <Modal.Title as="h6" className="m-0">
          Link to Patient — {conversation?.displayPhone}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>
          <small className="text-muted">
            Find the patient this WhatsApp number belongs to. Their future
            messages will be filed against their record.
          </small>
        </p>
        {saving ? (
          <div className="text-center py-4">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : (
          <PatientSearch onPatientSelect={link} />
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onHide} disabled={saving}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
